import { useNavigate } from "react-router-dom";
import '../../assets/css/Custom.css';
import { AiOutlineClose } from "react-icons/ai";
import { CiLocationArrow1 } from "react-icons/ci";
import { FaCalendarAlt } from "react-icons/fa";
import Layout from "../../layouts/Layout";
import { useEffect, useState } from "react";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector, useDispatch } from "react-redux";
import { formatDistanceToNow } from 'date-fns';
import { toast } from "react-toastify";
import { saveUnseenData } from "../../redux/UserDataSlice";
import '../../assets/css/Notification.css';
import { HashLoader } from "react-spinners";
import WebSocketInstance from "../../components/WebSocket"; 

const NotificationItem = ({
  keyId,
  title,
  time,
  location,
  host,
  message,
  backgroundColor,
  timeAgo,
  notificationData,
  setNotifictionData,
  status,
  recieverType
}) => {
  const { accessToken } = useSelector((state) => state.loginInfo);
  const navigate = useNavigate();

  const onClickNotification = async () => {
    const filteredData = notificationData?.find(item => item.id === keyId);
    const gameId = filteredData?.additionalData?.gameId;

    try {
      if (filteredData.type === 'Game Invitation') {
        const result = await apiHandler({
          url: `${endpoint.FETCH_INVITATION}?gameId=${gameId}`,
          method: "GET",
          authToken: accessToken?.accessToken,
        });

        if (result?.data?.message || result?.data?.applied === true) {
          toast.success(result?.data?.message);
        }

        navigate(`/game-details/${gameId}`, { state: { result } });

      } else if (filteredData.type === 'Game Request') {
        navigate('/requested-to-join-list', { state: { gameId } });
      } else {
        navigate(`/game-details/${gameId}`);
      }

    } catch (error) {
      console.error("Error processing invitation:", error);
      toast.error("An error occurred");
    }
  };

  return (
    <div className="notification-content-wrapper w-100" onClick={()=>onClickNotification()}>
      <div className="card-body" style={{ background: 'white', padding: '11px' }}>
        <div className={`p-2 ${backgroundColor}`} style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px' }}>
          <div className=" mb-1 mb-sm-2 d-flex justify-content-between align-items-center">
            <p className="mb-0 text-truncate text-center notification-messaage-text ps-2 pe-2"
              style={{
                backgroundColor: recieverType === "HOST"
                  ? '#019834'
                  : recieverType === "PARTICIPANT"
                    ? "#7e29d5"
                    : recieverType === "MINOR"
                      ? "#0099cc"
                      : recieverType === "MINOR_PARTICIPANT"
                        ? '#fc9d10'
                        : '#019834'
              }}>
              {message}
            </p>
            <div className="mb-1 text-end">
              <span className="text-muted" style={{ fontSize: "0.75rem" }}>{timeAgo}</span>
            </div>
          </div>
          <div className="row">
            <ul className="list-unstyled row mb-0 mb-sm-0" style={{ fontSize: "0.8rem", lineHeight: "1.5" }}>
              <div className="col-lg-5">
                <li className="p-0 p-sm-2" style={{ color: '#71727A' }}><><CiLocationArrow1 /></> {location}</li>
              </div>
              <div className="col-lg-5">
                <h6 className="card-title mb-0 text-truncate" style={{ fontSize: "18px", fontWeight: "500", color: '#006FFD' }}>
                  {title}
                </h6>
              </div>
            </ul>
          </div>
          <ul className="list-unstyled row host-timer-wrapper mb-0 mb-sm-2 d-flex align-items-center d-sm-block" style={{ fontSize: "0.8rem", lineHeight: "1.5"}}>
            <div className="col-6 col-sm-6 col-lg-6">
              <li className=" p-0 p-sm-2 pt-1 mt-1 mt-sm-0 mb-1 mb-sm-0"  style={{ color: '#71727A' }} >Host : {host}</li>
            </div>
            <div className="col-6 col-sm-6 col-lg-6 " style={{ textAlign: 'right' }}>
              <li className="p-0 p-sm-2" style={{ color: '#71727A' }}><FaCalendarAlt />{time}</li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

const Notifications = () => {
  const { accessToken, userAuthId } = useSelector((state) => state.loginInfo);
  const [notificationData, setNotifictionData] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [showSpinner, setShowSpinner] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiHandler({
          url: endpoint.NOTIFICATION_PENDING,
          method: "GET",
          authToken: accessToken?.accessToken,
        });

        setShowSpinner(false);
        if (result?.data?.notifications) {
          setNotifictionData(result.data.notifications);
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setShowSpinner(false);
      }
    };

    fetchData();
  }, [notifications]);

  useEffect(() => {
    if (!userAuthId) return;

    const destination = `/notification/${userAuthId}`;

    const setupWebSocket = async () => {
      try {
        await WebSocketInstance.connect();
        await WebSocketInstance.subscribe(destination, (payload) => {
          setNotifications((prev) => [...prev, payload]);
        });
      } catch (error) {
        console.error("WebSocket connection or subscription failed:", error);
      }
    };

    setupWebSocket();

    return () => {
      WebSocketInstance.unsubscribe(destination);
    };
  }, [userAuthId]);

  useEffect(() => {
    if (notifications.length > 0) {
      setNotifictionData((prev) => [...notifications, ...prev]);
    }
  }, [notifications]);

  useEffect(() => {
    const unseen = notificationData?.filter(item => item?.seen === false);
    dispatch(saveUnseenData(unseen?.length));
  }, [notificationData, dispatch]);

  const formatDate = (startTime) => {
    const [day, month, yearAndTime] = startTime.split('-');
    const [year, time] = yearAndTime.split(' ');
    const isoString = `${year}-${month}-${day}T${time}`;
    const date = new Date(isoString);

    if (isNaN(date)) return 'Invalid Date';

    const dayNum = date.getDate();
    const monthName = date.toLocaleString('default', { month: 'short' });
    const startHour = date.getHours();
    const endHour = startHour + 1;
    const formattedStartHour = startHour % 12 || 12;
    const formattedEndHour = endHour % 12 || 12;
    const amPm = startHour < 12 ? 'AM' : 'PM';

    return `${dayNum} ${monthName}, ${formattedStartHour}-${formattedEndHour} ${amPm}`;
  };

  return (
    <>
      {!showSpinner ? (
        <Layout>
          {notificationData.length > 0 ? (
            <div>
              <h4 className="ms-3  mb-2 mb-sm-4 text-left pt-2 pt-sm-4 notification-txt">Notifications</h4>
              <div className= "p-2 p-sm-0 bg-white bg-sm-inherit">
              {notificationData.map((notification) => {
                const { id, additionalData, seen, createdDate, message, recieverType } = notification;
                const { gameName, hostName, startTime, courtName, status } = additionalData;

                const timeAgo = formatDistanceToNow(new Date(createdDate), { addSuffix: true });
                const formattedStartTime = formatDate(startTime);

                return (
                  <NotificationItem
                    key={id}
                    keyId={id}
                    title={gameName}
                    time={formattedStartTime}
                    location={courtName}
                    host={hostName}
                    message={message}
                    recieverType={recieverType}
                    backgroundColor={
                      seen
                        ? 'bg-light-seen'
                        : recieverType === 'HOST'
                          ? 'bg-light-draft'
                          : recieverType === 'PARTICIPANT'
                            ? 'bg-soft-yellow'
                            : recieverType === 'MINOR'
                              ? 'bg-light-green'
                              : recieverType === 'MINOR_PARTICIPANT'
                                ? 'bg-light-green'
                                : 'bg-light-seen'
                    }
                    timeAgo={timeAgo}
                    notificationData={notificationData}
                    setNotifictionData={setNotifictionData}
                    status={status}
                  />
                );
              })}
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
              <h3 className="fs-2 fw-2" style={{ fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)' }}>No New Notification</h3>
            </div>
          )}
        </Layout>
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
          <HashLoader color="#e48181" />
        </div>
      )}
    </>
  );
};

export default Notifications;
